import { useEffect, useState } from 'react';
import type * as DataModelHelpModule from '../dataModel';

export type DataModelHelp = typeof DataModelHelpModule;

let loading: Promise<DataModelHelp> | undefined;
let loaded: DataModelHelp | undefined;

function load(): Promise<DataModelHelp> {
  loading ??= import('../dataModel').then(
    (module) => (loaded = module),
    (error: unknown) => {
      // A failed chunk load can be retried on the next mount.
      loading = undefined;
      throw error;
    },
  );
  return loading;
}

/**
 * The data model help (table topics, KPIs, joins), loaded with the help content on first use.
 * `help` is undefined until it has loaded; `failed` when the chunk could not be loaded.
 */
export function useDataModelHelp(): { help: DataModelHelp | undefined; failed: boolean } {
  const [state, setState] = useState(() => ({ help: loaded, failed: false }));
  const ready = state.help !== undefined;
  useEffect(() => {
    if (ready) return;
    let active = true;
    load().then(
      (help) => {
        if (active) setState({ help, failed: false });
      },
      () => {
        if (active) setState({ help: undefined, failed: true });
      },
    );
    return () => {
      active = false;
    };
  }, [ready]);
  return state;
}
